import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class GsLegalEntitiesService {
  constructor(private _http: HttpClient) {
  }

  findAll(params) {
    return this._http.post<any>(`api/a/gov-services/legal-entity/applications/all`, params);
  }

  getApplicationPlaceCounts(collegeId, applicationId) {
    return this._http.get<any>(`api/a/gov-services/legal-entity/applications/` + collegeId + `/` + applicationId);
  }

  getApplicationPlaceCount(applicationPlaceCountId) {
    return this._http.get<any>(`api/a/gov-services/legal-entity/applications/dialog/` + applicationPlaceCountId);
  }

  saveApplicationPlaceCount(collegeId, applicationId, applicationPlaceCountId, dtoMap) {
    return this._http.post<any>(`api/a/gov-services/legal-entity/applications/` + collegeId + `/` + applicationId
      + `/` + applicationPlaceCountId, dtoMap);
  }

  saveApplicationPlaceCountApartSpecialization(collegeId, applicationId, applicationPlaceCountId, dtoMap) {
    return this._http.post<any>(`api/a/gov-services/legal-entity/applications/apartSpecialization/` + collegeId + `/` + applicationId
      + `/` + applicationPlaceCountId, dtoMap);
  }

  saveApplicationPayingPlaceCount(collegeId, applicationId, dto: any) {
    return this._http.post<any>(`api/a/gov-services/legal-entity/applications/paying/` + collegeId + `/` + applicationId, dto);
  }

  deleteApplicationPlaceCount(applicationPlaceCountId) {
    return this._http.delete<any>(`api/a/gov-services/legal-entity/applications/appPlaceCount/` + applicationPlaceCountId);
  }

  deleteApplicationPlaceCountApartSpecialization(applicationPlaceCountId, specCode) {
    return this._http.delete<any>(`api/a/gov-services/legal-entity/applications/appPlaceCount/` + applicationPlaceCountId + `/` + specCode);
  }

  deleteApplicationPayingPlaceCount(applicationPayingPlaceCountId) {
    return this._http.delete<any>(`api/a/gov-services/legal-entity/applications/appPlaceCount/paying/` + applicationPayingPlaceCountId);
  }

  deleteApplication(applicationId) {
    return this._http.delete<any>(`api/a/gov-services/legal-entity/applications/` + applicationId);
  }

  submitApplicationPlaceCounts(applicationId) {
    return this._http.post(`api/a/gov-services/legal-entity/applications/submit/` + applicationId, null);
  }

  rejectApplication(applicationId, reasonedRefusal) {
    return this._http.post(`api/a/gov-services/legal-entity/applications/reject/` + applicationId, reasonedRefusal);
  }

  completeApplication(applicationId) {
    return this._http.put(`api/a/gov-services/legal-entity/applications/complete/` + applicationId, null);
  }


}



// WEBPACK FOOTER //
// ./src/app/modules/user/services/gs-legal-entities.service.ts